(() => {
  const config = window.setupFeeConfig;
  if (!config) return;

  const feeId = Number(config.variantId);
  const eligible = new Set(
    config.eligibleProductIds.map(Number)
  );

  const root = window.Shopify?.routes?.root || "/";
  const nativeFetch = window.fetch.bind(window);

  let busy = false;
  let pending = false;
  let timer;

  async function api(path, options) {
    const response = await nativeFetch(root + path, options);

    if (!response.ok) {
      throw new Error("Cart request failed: " + response.status);
    }

    return response.json();
  }

  function post(data) {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    };
  }

  // Display the current fee in the cart notification.
  function updateNotice(showFee) {
    const notification = document.querySelector(
      "cart-notification"
    );

    if (!notification) return;

    // Remove any previous message.
    notification.querySelectorAll(
      ".setup-fee-message"
    ).forEach(element => element.remove());

    if (!showFee) return;

    const productArea = notification.querySelector(
      "#cart-notification-product"
    );

    if (!productArea) return;

    const notice = document.createElement("div");
    notice.className = "setup-fee-message";

    notice.style.cssText =
      "padding:12px 0;margin-top:12px;" +
      "border-top:1px solid #ddd;";

    const heading = document.createElement("strong");
    heading.textContent = "Design & Setup Fee: $10.00";

    const description = document.createElement("p");
    description.textContent =
      "One-time fee for orders of fewer than " +
      "10 qualifying items.";

    description.style.cssText =
      "font-size:12px;margin:4px 0 0;";

    notice.append(heading, description);
    productArea.after(notice);
  }

  // Refresh the cart icon and notification button.
  async function refreshDisplay(showFee) {
  // On the regular cart page, reload after the
  // setup fee has been added or removed.
  const cartPath = root + "cart";

  if (
    window.location.pathname.replace(/\/$/, "") ===
    cartPath.replace(/\/$/, "")
  ) {
    window.location.reload();
    return;
  }

  // Update the setup-fee message in the pop-up.
  updateNotice(showFee);

  // Refresh the cart icon and View Cart button.
  const response = await nativeFetch(
    root + "?sections=cart-icon-bubble,cart-notification-button"
  );

  if (!response.ok) {
    throw new Error("Cart display refresh failed");
  }

  const sections = await response.json();
  const parser = new DOMParser();

  for (const id of [
    "cart-icon-bubble",
    "cart-notification-button"
  ]) {
    if (!sections[id]) continue;

    const doc = parser.parseFromString(
      sections[id],
      "text/html"
    );

    const updated = doc.getElementById(id);
    const current = document.getElementById(id);

    if (updated && current) {
      current.innerHTML = updated.innerHTML;
    }
  }
}
  async function syncFee() {
    if (busy) {
      pending = true;
      return;
    }

    busy = true;

    try {
      const cart = await api("cart.js");

      // Count all qualifying products together.
      const quantity = cart.items.reduce(
        (total, item) =>
          total + (
            eligible.has(Number(item.product_id))
              ? item.quantity
              : 0
          ),
        0
      );

      // Charge the fee only for 1-9 items.
      const desired =
        quantity >= 1 && quantity <= 9 ? 1 : 0;

      const feeLines = cart.items.filter(
        item => Number(item.variant_id) === feeId
      );

      const current = feeLines.reduce(
        (total, item) => total + item.quantity,
        0
      );

      let changed = false;

      if (
        current !== desired ||
        feeLines.length > 1
      ) {
        if (desired === 1 && feeLines.length === 0) {
          await api(
            "cart/add.js",
            post({
              items: [{
                id: feeId,
                quantity: 1
              }]
            })
          );

          changed = true;
        } else {
          for (let i = 0; i < feeLines.length; i++) {
            const target = i === 0 ? desired : 0;

            if (feeLines[i].quantity === target) {
              continue;
            }

            await api(
              "cart/change.js",
              post({
                id: feeLines[i].key,
                quantity: target
              })
            );

            changed = true;
          }
        }
      }

      if (changed) {
        await refreshDisplay(desired === 1);
      } else {
        updateNotice(desired === 1);
      }

    } catch (error) {
      console.error("Setup fee error:", error);
    } finally {
      busy = false;

      if (pending) {
        pending = false;
        scheduleSync();
      }
    }
  }

  function scheduleSync(delay = 400) {
    clearTimeout(timer);
    timer = setTimeout(syncFee, delay);
  }

  // Detect changes to the Shopify cart.
  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);

    const url = String(
      args[0]?.url || args[0] || ""
    );

    if (
      response.ok &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)
    ) {
      scheduleSync(500);
    }

    return response;
  };

  // Detect cart updates published by your theme.
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      scheduleSync(500);
    });
  }

  // Refresh the message after the notification opens.
  const Notification = customElements.get(
    "cart-notification"
  );

  if (Notification) {
    const originalRender =
      Notification.prototype.renderContents;

    Notification.prototype.renderContents =
      function (...args) {
        const result = originalRender.apply(this, args);

        scheduleSync(300);

        return result;
      };
  }

  // Check the cart on page load.
  scheduleSync();
})();